<div class="form-check form-switch">
    <input class="form-check-input" type="checkbox" value="yes" [id]="'feedbackAcknowledged' + historyID()" switch [checked]="acknowledged() === 'yes'" (change)="sendAcknowledged()">
    <label class="form-check-label" [for]="'feedbackAcknowledged' + historyID()">
        Acknowledged
    </label>
</div>